// import RepositoryFactory from "@/apis";
// const companydash = RepositoryFactory.companydash;
import companydash from "../../apis/companydash";

export default {
  create({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await companydash.create(payload);
        commit("ADD_BOOKING", data.data);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },
  delete({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await companydash.delete(payload);

        // Update user details
        commit("DELETE_Dash_Details", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  edit({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await companydash.edit(payload);

        // Update user details
        commit("EDIT_DASH_DETAILS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_all({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await companydash.get_all(payload);

        commit("GET_COMPANY_DASH", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  generateEmployee({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await companydash.generateEmployee(payload);

        // commit("GET_COMPANY_DASH", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
